export const GET_VEHICLES = 'get-vehicles';

export default function getVehicles() {
  return {
    type: GET_VEHICLES,
  };
}
